import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  popup: false,
  popup2: false,

  popupInv: false,
  popupInv2: false,
  popupQuote: false,

  selectedInv: null,
  selectedQuote: null,
};

const popupSlice = createSlice({
  name: "popupSlice",
  initialState,

  reducers: {
    setPopup: (state, action) => {
      state.popup = action.payload;
    },

    setPopup2: (state, action) => {
      state.popup2 = action.payload;
    },

    setPopupInv: (state, action) => {
      state.popupInv = action.payload;
    },

    setPopupInv2: (state, action) => {
      state.popupInv2 = action.payload;
    },

    setPopupQuote: (state, action) => {
      state.popupQuote = action.payload;
    },

    openInvPopup: (state, action) => {
      state.selectedInv = action.payload;
      state.popupInv = true;
    },

    closeInvPopup: (state) => {
      state.popupInv = false;
      state.selectedInv = null;
    },

    openQuotePopup: (state, action) => {
      state.selectedQuote = action.payload;
      state.popupQuote = true;
    },

    closeQuotePopup: (state) => {
      state.popupQuote = false;
      state.selectedQuote = null;
    },
  },
});

export const {
  setPopup,
  setPopup2,
  setPopupInv,
  setPopupInv2,
  setPopupQuote,
  openInvPopup,
  closeInvPopup,
  openQuotePopup,
  closeQuotePopup,
} = popupSlice.actions;

export default popupSlice.reducer;